const envSettings = window as any;
export class Config {
  static api_url = envSettings.API_URL;
  static redirect_url = envSettings.REDIRECT_URL;
  static b2c_domain = envSettings.B2C_DOMAIN;
  static b2c_client_id = envSettings.B2C_CLIENT_ID;
  static portal_version = envSettings.portal_version;
}
